module.exports = __webpack_public_path__ + "img/cruzeiro-nacional.29bead33.png";